<template>
  <b-overlay :show="loading || saving">
    <div class="service-wages-container p-4">
      <div class="card shadow-sm border-0">
        <div
          class="card-header bg-light-blue py-3 d-flex justify-content-between align-items-center border-bottom"
        >
          <div class="text-center flex-grow-1">
            <!-- Updated by Jarir 2026-03-30 : Added Bangladesh Gazette header -->
            <p
              class="mb-1 font-weight-bold"
              style="color: #333; font-size: 0.85rem"
            >
              Bangladesh Gazette - বাংলাদেশ গেজেট
            </p>
            <h5 class="mb-1 font-weight-bold text-primary">Form No: 07</h5>
            <p class="mb-1 text-muted small">
              Under Section 7, Rules (1) and (2)
            </p>
            <p class="mb-1 text-muted small">Third Part (C)</p>
            <h6 class="mb-0 font-weight-bold">
              Service, Wages and Allowance Record
            </h6>
            <p class="mb-0 small bn-text">
              সার্ভিস রেকর্ড ও মজুরি এবং ভাতা সংক্রান্ত তথ্য
            </p>
          </div>
        </div>

        <div class="card-body p-0">
          <div class="table-responsive">
            <table class="table table-bordered mb-0 custom-table">
              <thead class="text-center bg-light-cyan">
                <!-- Row 1: Main column headers -->
                <tr>
                  <th
                    rowspan="2"
                    style="vertical-align: middle"
                  >
                    Date of Starting Current Position<br />
                    <small class="bn-text"
                      >বর্তমান পদে চাকরি আরম্ভের তারিখ</small
                     >
                    <br /><small class="text-muted">(১)</small>
                  </th>
                  <th
                    rowspan="2"
                    style="vertical-align: middle"
                  >
                    Job Title &amp; Card Number<br />
                    <small class="bn-text">চাকরির পদ ও কার্ড নম্বর</small>
                    <br /><small class="text-muted">(২)</small>
                  </th>
                  <th colspan="5" style="vertical-align: middle">
                    Monthly Wage Rate<br />
                    <small class="bn-text">মাসিক মজুরির হার</small>
                    <br /><small class="text-muted">(৩)</small>
                  </th>
                  <th
                    rowspan="2"
                    style="vertical-align: middle"
                  >
                    Other Allowances<br />
                    <small class="bn-text">অন্যান্য ভাতা</small>
                    <br /><small class="text-muted">(৪)</small>
                  </th>
                  <th
                    rowspan="2"
                    style="vertical-align: middle"
                  >
                    Total Provident Fund (if any)<br />
                    <small class="bn-text">মোট প্রভিডেন্ট ফান্ড (যদি থাকে)</small>
                    <br /><small class="text-muted">(৫)</small>
                  </th>
                  <th
                    rowspan="2"
                    style="vertical-align: middle"
                  >
                    Worker's Contribution Amount<br />
                    <small class="bn-text">শ্রমিকের প্রদেয় টাকা</small>
                    <br /><small class="text-muted">(৬)</small>
                  </th>
                  <th
                    rowspan="2"
                    style="vertical-align: middle"
                  >
                    Owner's Contribution Amount<br />
                    <small class="bn-text">মালিকের প্রদেয় টাকা</small>
                    <br /><small class="text-muted">(৭)</small>
                  </th>
                  <th rowspan="2" style="vertical-align: middle">
                    Signature of Owner/ Authorized Person<br />
                    <small class="bn-text"
                      >মালিক/প্রাধিকারপ্রান্ত ব্যক্তির স্বাক্ষর</small
                    >
                    <br /><small class="text-muted">(৮)</small>
                  </th>
                  <th rowspan="2" style="vertical-align: middle">
                    Worker's Signature/ Thumb Impression<br />
                    <small class="bn-text">শ্রমিকের স্বাক্ষর/টিপসই</small>
                    <br /><small class="text-muted">(৯)</small>
                  </th>
                </tr>
                <!-- Row 2: Wage sub-column headers -->
                <tr>
                  <th>
                    Basic Wage<br />
                    <small class="bn-text">মূল মজুরি</small>
                  </th>
                  <th>
                    House Rent Allowance<br />
                    <small class="bn-text">বাড়ি ভাড়া ভাতা</small>
                  </th>
                  <th>
                    Medical Allowance<br />
                    <small class="bn-text">চিকিৎসা ভাতা</small>
                  </th>
                  <th>
                    Bonus (if any)<br />
                    <small class="bn-text">বোনাস</small>
                  </th>
                  <!-- Updated by Jarir 2026-04-29 -->
                  <th>
                    Other Benefits<br />
                    <small class="bn-text">অন্যান্য সুবিধা</small>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="paginatedData.length == 0 && !loading">
                  <td colspan="13" class="text-center py-5 text-muted">
                    No records found.
                    <!-- Updated: 2026-04-19 18:45:00 -->
                    <br><span class="bn-text">কোন তথ্য পাওয়া যায়নি</span>
                  </td>
                </tr>
                <tr
                  v-for="(item, index) in paginatedData"
                  :key="item.id"
                  class="text-center"
                >
                  <!-- Updated by Jarir 2026-03-24 : show Active badge on latest record -->
                  <td>
                    {{ formatDate(item.date_of_starting_current_position) }}
                    <br v-if="item.id == activeRecordId" />
                    <span
                      v-if="item.id == activeRecordId"
                      style="color: #28a745; font-size: 11px"
                      >&#10004; (Active)</span
                    >
                  </td>
                  <td>
                    <div class="text-left">
                      <div class="font-weight-bold">
                        {{ getJsonValue(item.job_title_card_number, "en") }}
                      </div>
                      <div class="bn-text small text-muted 1111">
                        {{ getJsonValue(item.job_title_card_number, "bn") }}
                      </div>
                    </div>
                  </td>
                  <!-- Monthly Wage Rate — 5 sub-columns under colspan="5" header (3) -->
                   <!-- alpha fix- added class="text-right" -->
                  <td class="text-right">{{ getMwrValue(item.monthly_wage_rate, "basic_wage") }}</td>
                  <td class="text-right">{{ getMwrValue(item.monthly_wage_rate, "house_rent_allowance") }}</td>
                  <td class="text-right">{{ getMwrValue(item.monthly_wage_rate, "medical_allowance") }}</td>
                  <td class="text-right">{{ getMwrValue(item.monthly_wage_rate, "bonus") }}</td>
                  <td class="text-right">{{ getMwrValue(item.monthly_wage_rate, "other_benefits") }}</td>
                  <!-- Updated by Jarir 2026-03-24 : show numeric total only -->
                  <td class="text-right">
                    {{
                      sumAllowances(getJsonValue(item.other_allowances, "en"))
                    }}
                  </td>
                  <td>
                    <div class="text-left">
                      <div>
                        {{ getJsonValue(item.total_payable_fund, "en") }}
                      </div>
                      <div class="bn-text small text-muted">
                        {{ getJsonValue(item.total_payable_fund, "bn") }}
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="text-left">
                      <div>
                        {{ getJsonValue(item.worker_amount_received, "en") }}
                      </div>
                      <div class="bn-text small text-muted">
                        {{ getJsonValue(item.worker_amount_received, "bn") }}
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="text-left">
                      <div>
                        {{ getJsonValue(item.owner_amount_received, "en") }}
                      </div>
                      <div class="bn-text small text-muted">
                        {{ getJsonValue(item.owner_amount_received, "bn") }}
                      </div>
                    </div>
                  </td>
                  <td>
                    <b-link v-if="item.owner_signature" @click="downloadWithName(item.owner_signature, 'Owner_Signature')">
                      <b-icon icon="download" scale="1.2"></b-icon> Download
                    </b-link>
                    <!-- Updated by Jarir 2026-03-30 -->
                    <span v-else class="text-muted small"
                      >No Signatories found. Add a Signatory in HR Management Portal</span
                    >
                  </td>
                  <td>
                    <div class="d-flex justify-content-center">
                      <b-link
                        v-if="item.worker_signature"
                        @click="downloadWithName(item.worker_signature, 'Worker_Signature')"
                        class="mr-2"
                      >
                        <b-icon icon="download" scale="1.2"></b-icon> Signature
                      </b-link>
                      <b-link
                        v-if="item.worker_thumb_impression"
                        @click="downloadWithName(item.worker_thumb_impression, 'Thumb_Impression')"
                      >
                        <b-icon icon="download" scale="1.2"></b-icon> Impression
                      </b-link>
                      <span v-if="!item.worker_signature && !item.worker_thumb_impression"
                        ></span
                      >
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div
          class="card-footer bg-white border-top py-3"
          v-if="pagination.pages > 1"
        >
          <b-pagination-nav
            v-model="pagination.currentPage"
            :number-of-pages="pagination.pages"
            base-url="#"
            prev-text="Previous"
            next-text="Next"
            first-number
            last-number
            align="center"
            class="mb-0"
          ></b-pagination-nav>
        </div>
      </div>
    </div>
  </b-overlay>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      apiPrefix: "/admin-service-book",
      employee_id: null,
      items:       [],
      loading:     false,
      baseUrl:     window.location.origin,
      length:      10,
      pagination:  { currentPage: 1, total: "", pages: 1 },
    };
  },
  computed: {
    paginatedData() {
      // Data is already sorted by the backend (Active record at top, then date DESC)
      return this.paginate(this.items, this.length, this.pagination.currentPage);
    },
    // Updated by Jarir 2026-03-24 : active record = latest start date
    activeRecordId() {
      if (!this.items || this.items.length == 0) return null;
      // The items are already sorted by date DESC by the backend
      var latest = this.items[0];

      // Updated by Jarir 2026-04-28 — Check internal status flag from auto-fetch
      var mwr = latest.monthly_wage_rate;
      if (typeof mwr === "string") {
        try { mwr = JSON.parse(mwr); } catch (e) { mwr = {}; }
      }
      if (mwr && mwr.is_active === 0) return null;

      return latest.id;
    },
  },
  created() {
    this.fetchData();
  },
  mounted() {},
  methods: {
    fetchAsBlob(url) {
      if (!url) return Promise.resolve(null);
      return fetch(url, { credentials: "same-origin" })
        .then((r) => r.blob())
        .then((blob) => URL.createObjectURL(blob))
        .catch(() => url);
    },
    fetchData() {
      this.loading = true;
      axios
        .get(this.apiPrefix + "/wages-records")
        .then((response) => {
          this.items = response.data || [];
          // Updated by Jarir 2026-04-26 — backend returns base64 data URIs; pass directly, not baseUrl+path
          this.items.forEach((item) => {
            if (item.owner_signature) {
              this.fetchAsBlob(item.owner_signature).then((b) => this.$set(item, "_ownerBlob", b));
            }
            if (item.worker_signature) {
              this.fetchAsBlob(item.worker_signature).then((b) => this.$set(item, "_workerBlob", b));
            }
            if (item.worker_thumb_impression) {
              this.fetchAsBlob(item.worker_thumb_impression).then((b) => this.$set(item, "_thumbBlob", b));
            }
          });
        })
        .catch(() => {
          this.$bvToast.toast("Error loading records", {
            title: "Error",
            variant: "danger",
            solid: true,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // Updated by Jarir 2026-04-26 — backend streams PDF directly; use blob responseType
    downloadPdf(lang = "both") {
      this.loading = true;
      axios
        .post(this.apiPrefix + "/download-wages-records-pdf", { lang: lang }, { responseType: "blob" })
        .then((response) => {
          this.global_download_file_content(response);
        })
        .catch(() => {
          this.$bvToast.toast("Error downloading PDF", {
            title: "Error", variant: "danger", solid: true,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    downloadWithName(path, name) {
      if (!path) return;
      if (path.startsWith('data:image/')) {
        try {
          const parts = path.split(';base64,');
          const contentType = parts[0].split(':')[1];
          const raw = window.atob(parts[1]);
          const rawLength = raw.length;
          const uInt8Array = new Uint8Array(rawLength);
          for (let i = 0; i < rawLength; ++i) uInt8Array[i] = raw.charCodeAt(i);
          const blob = new Blob([uInt8Array], { type: contentType });
          const blobUrl = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = blobUrl;
          link.download = name + '.' + contentType.split('/')[1];
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          setTimeout(() => URL.revokeObjectURL(blobUrl), 100);
          return;
        } catch (e) {
          console.error("Base64 download failed, falling back to direct URL", e);
        }
      }
      const url = path.startsWith("http") || path.startsWith("data:") ? path : "/" + path;
      const link = document.createElement("a");
      link.href = url;
      link.download = name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    getJsonValue(field, lang) {
      if (!field) return "";
      if (typeof field === "object" && field !== null) return field[lang] || "";
      if (typeof field === "string") {
        try {
          const parsed = JSON.parse(field);
          return parsed[lang] || "";
        } catch (e) {
          return field;
        }
      }
      return "";
    },
    getMwrValue(field, key) {
      console.log('field', field, 'key', key);

      if (!field) return "";
      let parsed = field;
      if (typeof field === "string") {
        try {
          parsed = JSON.parse(field);
        } catch (e) {
          // If not JSON but key is basic_wage, the field itself might be the wage string
          return key === "basic_wage" ? field : "";
        }
      }

      if (typeof parsed === "object" && parsed !== null) {
        // Case A: Field is a bilingual object (e.g. legacy or mis-saved data)
        if ("en" in parsed || "bn" in parsed) {
          return key === "basic_wage" ? (parsed.en || parsed.bn || "") : "";
        }
        // Case B: Field is a flat object containing wage keys (standard format)
        const val = parsed[key];
        return val !== undefined && val !== null ? String(val) : "";
      }
      return "";
    },
    // Updated by Jarir 2026-04-29 — handles both plain number (new) and "Title: Value" (old) formats
    sumAllowances(str) {
      if (!str || str == "" || str == "-") return 0;
      if (str.indexOf(":") === -1) {
        var plain = parseFloat(str);
        return isNaN(plain) ? 0 : plain;
      }
      var total = 0;
      var parts = str.split(",");
      for (var i = 0; i < parts.length; i++) {
        var pair = parts[i].split(":");
        if (pair.length == 2) {
          var num = parseFloat(pair[1].trim());
          if (!isNaN(num)) total += num;
        }
      }
      return total;
    },
    formatDate(date) {
      if (!date) return "";
      const d = new Date(date);
      if (isNaN(d.getTime())) return "";
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
    },
  },
};
</script>

<style scoped>
.bn-text {
  font-family: "notosansbengali", sans-serif;
}
.bg-light-blue {
  background-color: rgb(234, 246, 255) !important;
}
.bg-light-cyan {
  background-color: #e3f2fd;
}
.custom-table th {
  font-size: 0.82rem;
  vertical-align: middle;
}
.custom-table td {
  vertical-align: middle;
  font-size: 0.9rem;
}
.sig-thumb {
  max-height: 40px;
  max-width: 100px;
}
.img-preview {
  max-height: 80px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

/* Sorting styles */
.sorting {
  position: relative;
  padding-right: 30px !important;
}
.sorting:after,
.sorting:before {
  position: absolute;
  bottom: 0.9em;
  display: block;
  opacity: 0.3;
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
}
.sorting:before {
  right: 1em;
  content: "\f0de"; /* fa-sort-up */
}
.sorting:after {
  right: 1em;
  content: "\f0dd"; /* fa-sort-down */
  top: 1.1em;
}
.sorting_asc:before {
  opacity: 1;
}
.sorting_desc:after {
  opacity: 1;
}

.add-entry-btn {
  border-radius: 20px;
  font-weight: 500;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
</style>
